export default __webpack_public_path__ + "static/media/RAMANA.bd8ebc5f.jpeg";